var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-device-test-detail" }, [
    _c("div", { staticClass: "device-info" }, [
      _c("img", {
        staticClass: "device-icon",
        attrs: { src: _vm.ossPondHost + "img/xiazeng_icon.png" }
      }),
      _c("div", { staticClass: "device-num" }, [
        _vm._v(_vm._s(_vm.displayNum))
      ]),
      _c("div", { staticClass: "device-signal" }, [
        _vm._v("信号强度:" + _vm._s(_vm.displaySignal))
      ])
    ]),
    _c("div", { staticClass: "test-list" }, [
      _c("div", { staticClass: "test-item" }, [
        _c("div", { staticClass: "test-label" }, [_vm._v("1.指示灯")]),
        _c(
          "div",
          { staticClass: "test-btn", on: { click: _vm.onclickLightTest } },
          [_vm._v("测试")]
        )
      ]),
      _c("div", { staticClass: "test-item" }, [
        _c("div", { staticClass: "test-label" }, [_vm._v("2.电机测试")]),
        _c("div", { staticClass: "test-btns" }, [
          _c(
            "div",
            { staticClass: "test-btn", on: { click: _vm.onclickMotorReverse } },
            [_vm._v("上升")]
          ),
          _c(
            "div",
            { staticClass: "test-btn", on: { click: _vm.onclickMotorForward } },
            [_vm._v("下降")]
          )
        ])
      ]),
      _c("div", { staticClass: "test-item" }, [
        _c("div", { staticClass: "test-label" }, [_vm._v("3.补光灯")]),
        _c("div", { staticClass: "test-btns" }, [
          _c(
            "div",
            { staticClass: "test-btn", on: { click: _vm.onclickFillLightOff } },
            [_vm._v("关闭")]
          ),
          _c(
            "div",
            { staticClass: "test-btn", on: { click: _vm.onclickFillLightOn } },
            [_vm._v("开启")]
          )
        ])
      ]),
      _c("div", { staticClass: "test-item" }, [
        _c("div", { staticClass: "test-label" }, [_vm._v("4.蜂鸣器")]),
        _c(
          "div",
          { staticClass: "test-btn", on: { click: _vm.onclickBuzzerTest } },
          [_vm._v("测试")]
        )
      ]),
      _c("div", { staticClass: "test-item camera-item" }, [
        _c("div", { staticClass: "test-item-row" }, [
          _c("div", { staticClass: "test-label" }, [_vm._v("5.摄像头")]),
          _c(
            "div",
            { staticClass: "test-btn", on: { click: _vm.onclickCameraTest } },
            [_vm._v("拍照")]
          )
        ]),
        _vm.device.imageUrl
          ? _c("div", { staticClass: "photo-bar" }, [
              _c("span", { staticClass: "photo-text" }, [
                _vm._v(_vm._s(_vm.photoTimeText))
              ]),
              _c(
                "span",
                {
                  staticClass: "photo-link",
                  on: { click: _vm.onclickViewPhoto }
                },
                [_vm._v("去查看")]
              )
            ])
          : _vm._e()
      ]),
      _c("div", { staticClass: "test-item" }, [
        _c("div", { staticClass: "test-label" }, [_vm._v("6.重力感应器")]),
        _c("div", { staticClass: "test-right" }, [
          _c("span", { staticClass: "test-state" }, [
            _vm._v(_vm._s(_vm.gravityStateText))
          ]),
          _c(
            "span",
            {
              staticClass: "test-more",
              on: {
                click: function($event) {
                  return _vm.onclickMore("gravity")
                }
              }
            },
            [_vm._v("更多")]
          )
        ])
      ]),
      _c("div", { staticClass: "test-item" }, [
        _c("div", { staticClass: "test-label" }, [_vm._v("7.底部限位开关")]),
        _c("div", { staticClass: "test-right" }, [
          _c("span", { staticClass: "test-state" }, [
            _vm._v(_vm._s(_vm.limitStateText))
          ]),
          _c(
            "span",
            {
              staticClass: "test-more",
              on: {
                click: function($event) {
                  return _vm.onclickMore("limit")
                }
              }
            },
            [_vm._v("更多")]
          )
        ])
      ])
    ]),
    _vm.showRecordModal
      ? _c(
          "div",
          {
            staticClass: "record-modal",
            on: {
              touchmove: function($event) {
                $event.preventDefault()
              },
              click: function($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                _vm.showRecordModal = false
              }
            }
          },
          [
            _c("div", { staticClass: "record-box" }, [
              _c("div", { staticClass: "record-title" }, [_vm._v("开合记录")]),
              _c("div", { staticClass: "record-tabs" }, [
                _c(
                  "div",
                  {
                    class: [
                      "record-tab",
                      { active: _vm.activeTab === "gravity" }
                    ],
                    on: {
                      click: function($event) {
                        _vm.activeTab = "gravity"
                      }
                    }
                  },
                  [_vm._v("重力感应器")]
                ),
                _c(
                  "div",
                  {
                    class: [
                      "record-tab",
                      { active: _vm.activeTab === "limit" }
                    ],
                    on: {
                      click: function($event) {
                        _vm.activeTab = "limit"
                      }
                    }
                  },
                  [_vm._v("底部限位")]
                )
              ]),
              _c(
                "div",
                {
                  staticClass: "record-list",
                  on: {
                    touchmove: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _vm._l(_vm.currentRecords, function(record, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "record-row" },
                      [
                        _c("span", { staticClass: "record-state" }, [
                          _vm._v(_vm._s(record.text))
                        ]),
                        _c("span", { staticClass: "record-time" }, [
                          _vm._v(_vm._s(record.time))
                        ])
                      ]
                    )
                  }),
                  !_vm.currentRecords.length
                    ? _c("div", { staticClass: "record-empty" }, [
                        _vm._v("暂无记录")
                      ])
                    : _vm._e()
                ],
                2
              )
            ]),
            _c("img", {
              staticClass: "record-close",
              attrs: {
                src:
                  "https://static.yudada.com/wechat/pond/img/icon_close_modal.png"
              },
              on: {
                click: function($event) {
                  _vm.showRecordModal = false
                }
              }
            })
          ]
        )
      : _vm._e(),
    _vm.showPreviewImg
      ? _c(
          "div",
          {
            staticClass: "preview-mask",
            on: {
              click: function($event) {
                _vm.showPreviewImg = false
              }
            }
          },
          [_c("img", { attrs: { src: _vm.device.imageUrl } })]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }